export const ru = {
  'error-screen-title': 'Ошибка'
}
